<template>
<div>
    <TableActionHeader @filterChange="onFilterChange" @newItem="onNewItem"></TableActionHeader> 
    <b-table 
        striped 
        hover 
        selectable 
        select-mode="single" 
        @row-selected="onRowSelected" 
        :items="items" 
        :fields="fields" 
        :filter="filter"
        @filtered="onFiltered"
        :per-page="perPage"
        :current-page="currentPage"
        ref="table">

        <template v-slot:cell(thumbnail)="data">
            <!-- {{data.item}} -->
            <div v-if="data.item.thumbnail">
                <b-img  v-if="data.item.mediaType == 'image'" :src="data.item.thumbnail.base64" alt=""/>
                <div class="wrap" v-if="data.item.mediaType == 'url'">
                <iframe class="frame" :src="data.item.url"></iframe>
                </div>
            </div>
        </template>

    </b-table>

    <TablePagination 
        :total-rows="totalRows" 
        :per-page="perPage" 
        @pageChange="onPageChange">
    </TablePagination>
</div>
</template>

<script>

import media from '@/store/content/media.js'

export default {
  components: {  },
    data() {
        return {
            filteredRows: 0,
            perPage: 10,
            currentPage: 1,
            fields: [
                { key: "name", label: this.$t('media.name'), sortable: true },
                { key: "mediaType", label: this.$t('media.type'), sortable: true},
                { key: "thumbnail", label: this.$t('media.thumbnail'), editable:true, image: true}
            ],
            filter: ""
        }
    },
    created() {
        if (!this.$store.state.media ) this.$store.registerModule("media" , media)
        this.$store.dispatch('media/listAndThumbnails')
    },
    computed: {
        items() {
            var mediaList = this.$store.state.media.list;
            if(mediaList == null) {
                return [];
            }

            return mediaList;
        },
        totalRows() {
            return this.filter ?  this.filteredRows : this.items.length;
        }
    },
    methods: {
        onFilterChange(filter) {
            this.filter = filter;
        },
        onNewItem() {
            this.$emit('newItem');
        },
        onRowSelected(items) {
            this.$emit('selectItem' , items[0] );
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length;
            this.currentPage = 1;
        },
        onPageChange(selectedPage) {
            this.currentPage = selectedPage;
        }
    }
}

</script>

<style lang="scss" scoped>
   .wrap
    {
        width: 96px;
        height: 54px;
        padding: 0;
        overflow: hidden;
    }

    .frame
    {
        width: 1920px;
        height: 1080px;
        border: 0;

        -ms-transform: scale(0.05);
        -moz-transform: scale(0.05);
        -o-transform: scale(0.05);
        -webkit-transform: scale(0.05);
        transform: scale(0.05);

        -ms-transform-origin: 0 0;
        -moz-transform-origin: 0 0;
        -o-transform-origin: 0 0;
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
</style>